module.exports = __webpack_public_path__ + "static/media/ping-grey.a980c919.png";